export const ACTIONS = [
    {
        id: "reroute-life-support",
        sectionId: "bridge",
        name: "Приоритет жизнеобеспечению",
        description: "Перенаправить резервную мощность генераторам кислорода.",
        durationSeconds: 3,
        tone: "normal"
    },
    {
        id: "reroute-reactor",
        sectionId: "bridge",
        name: "Приоритет реактору",
        description: "Питать контуры стабилизации за счёт остальных систем.",
        durationSeconds: 3,
        tone: "warning"
    },
    {
        id: "vent-engineering",
        sectionId: "bridge",
        name: "Аварийная вентиляция инженерного",
        description: "Откачать воздух. Пожар ослабнет, но отсек станет смертельно опасным без скафандра.",
        durationSeconds: 2,
        tone: "danger"
    },
    {
        id: "field-treatment",
        sectionId: "medbay",
        name: "Пройти лечение",
        description: "Восстановить здоровье с помощью медицинского модуля.",
        durationSeconds: 5,
        tone: "normal"
    },
    {
        id: "seal-oxygen-leak",
        sectionId: "life-support",
        name: "Перекрыть утечку кислорода",
        description: "Найти повреждённую магистраль и установить герметизирующий хомут.",
        durationSeconds: 8,
        tone: "warning"
    },
    {
        id: "oxygen-purge",
        sectionId: "life-support",
        name: "Запустить продувку",
        description: "Повысить содержание кислорода во всех подключённых отсеках.",
        durationSeconds: 5,
        tone: "normal"
    },
    {
        id: "stabilize-reactor",
        sectionId: "reactor",
        name: "Стабилизировать реактор",
        description: "Вручную выровнять магнитное поле активной зоны.",
        durationSeconds: 9,
        tone: "danger"
    },
    {
        id: "extinguish-fire",
        sectionId: "engineering",
        name: "Тушить пожар вручную",
        description: "Использовать локальную систему пожаротушения.",
        durationSeconds: 9,
        tone: "danger"
    },
    {
        id: "repair-grid",
        sectionId: "engineering",
        name: "Восстановить энергосеть",
        description: "Заменить оплавленные соединители распределительной шины.",
        durationSeconds: 8,
        tone: "warning"
    },
    {
        id: "repressurize-engineering",
        sectionId: "engineering",
        name: "Герметизировать и наполнить отсек",
        description: "Закрыть аварийные клапаны и вернуть воздух в инженерный отсек.",
        durationSeconds: 6,
        tone: "normal"
    },
    {
        id: "secure-cargo",
        sectionId: "cargo",
        name: "Закрепить груз",
        description: "Остановить повреждение корпуса сорвавшимися контейнерами.",
        durationSeconds: 7,
        tone: "warning"
    },
    {
        id: "repressurize-airlock",
        sectionId: "airlock",
        name: "Наполнить шлюз воздухом",
        description: "Закрыть внешний люк и выполнить цикл герметизации.",
        durationSeconds: 5,
        tone: "normal"
    }
];
export function getActionsForSection(sectionId) {
    return ACTIONS.filter((action) => action.sectionId === sectionId);
}
export function getAction(actionId) {
    return ACTIONS.find((action) => action.id === actionId);
}
//# sourceMappingURL=actions.js.map